<template>
        <!-- לתקן את הVALUE -->
  <svg height="0">
    <filter
      v-for="(color, index) of getColorsDST()"
      :key="index"
      :id="'ColorFilter-' + color.colorID"
    >
      <feColorMatrix
        :values="getMatrix(color)"
        style="color-interpolation-filters: sRGB"
      />
    </filter>
    <filter
      v-for="(color, index) of getColorsSVG()"
      :key="index"
      :id="'ColorFilterSVG-' + color.colorID"
    >
      <feColorMatrix
        :values="getMatrix(color)"
        style="color-interpolation-filters: sRGB"
      />
    </filter>
  </svg>
</template>
 
<script>
import { designerStore } from "@/stores/designerStore";
 
export default {
  setup() {
    const store = designerStore();
    return {
      store,
    };
  },
  methods: {
    getColorsSVG() {
        return this.store.allColorsSVG.value;
    },
     getColorsDST() {
        return this.store.allColors.value;
    },
    getMatrix(color) {
      // this.store.currentEditingProps.isDesignDst = true;
      if((this.store.currentEditingProps.productType == 'WoodEngrave' || this.store.currentEditingProps.productType == 'GlassEngrave') || this.store.blackForWoodAndGlassId == color.colorID) {
        return `0 0 0 0 0
                0 0 0 0 0
                0 0 0 0 0
                0 0 0 0.55 0`;
      } else {
      let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
        color.color
      );
 
      let c = {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      };
 
      return `${c.r / 255.0}    0       0      0      0
              0         ${c.g / 255.0}  0      0      0
              0         0       ${c.b / 255.0} 0      0
              0         0       0      1      0`;
    }
  }
  },
};
</script>